import { THEME_IDS } from './themeIds.js';

/** @typedef {'default' | 'big-top'} ThemeId */

/**
 * @typedef {object} ThemeDefinition
 * @property {ThemeId} id
 * @property {string} label
 * @property {'default' | 'big-top'} skillVariant
 * @property {'big-top' | undefined} uiVariant
 * @property {string | null} bodyClass
 * @property {string | null} appContentClass
 * @property {Partial<Record<'skillComplete' | 'progressFeedback' | 'viewProfile' | 'userProgress' | 'courseHome' | 'loginWithGoogle' | 'logout' | 'splash' | 'sectionHome' | 'pathwayHome' | 'reviewHome', string>>} pageClasses
 */

/** @type {Record<ThemeId, ThemeDefinition>} */
export const themeRegistry = {
  [THEME_IDS.DEFAULT]: {
    id: THEME_IDS.DEFAULT,
    label: 'Default',
    skillVariant: 'default',
    uiVariant: undefined,
    bodyClass: null,
    appContentClass: null,
    pageClasses: {},
  },
  [THEME_IDS.BIG_TOP]: {
    id: THEME_IDS.BIG_TOP,
    label: 'Big Top Arcade',
    skillVariant: 'big-top',
    uiVariant: 'big-top',
    bodyClass: 'app-theme--big-top',
    appContentClass: 'app-content--skill-big-top',
    pageClasses: {
      skillComplete: 'skill-complete--big-top',
      progressFeedback: 'progress-feedback--big-top',
      viewProfile: 'view-profile--big-top',
      userProgress: 'user-progress--big-top',
      courseHome: 'course-home--big-top',
      loginWithGoogle: 'login-with-google--big-top',
      logout: 'logout--big-top',
      splash: 'splash--big-top',
      sectionHome: 'pathway-home--big-top',
      pathwayHome: 'pathway-home--big-top',
      skillFrame: 'skill-frame--big-top',
      calculusHome: 'calculus-home--big-top',
      // Legacy cream shell for quiz-admin wrappers; teacher views use TeacherPageShell.
      teacherAdmin: 'app-page-cream--big-top',
      siteAdmin: 'app-page-cream--big-top',
      reviewHome: 'review-home--big-top',
      teacherOnboarding: 'teacher-onboarding--big-top',
      classInvite: 'class-invite--big-top',
      about: 'about--big-top',
      contact: 'contact--big-top',
    },
  },
};

/**
 * @param {ThemeId} themeId
 * @returns {ThemeDefinition}
 */
export function getTheme(themeId) {
  return themeRegistry[themeId] ?? themeRegistry[THEME_IDS.DEFAULT];
}

/**
 * @param {ThemeDefinition} theme
 */
export function getThemeHelpers(theme) {
  return {
    themeId: theme.id,
    theme,
    skillVariant: theme.skillVariant,
    uiVariant: theme.uiVariant,
    bodyClass: theme.bodyClass,
    appContentClass: theme.appContentClass,
    isThemed: theme.id !== THEME_IDS.DEFAULT,
    pageClass(pageKey) {
      return theme.pageClasses[pageKey] ?? null;
    },
  };
}
